/* eslint-disable no-nested-ternary */
/* eslint-disable prettier/prettier */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import classes from './styles.module.scss';
import VideoResume from './VideoResume';
import { useUserStore } from '../../../../store';
import Textarea from '../../../Form/Textarea';

function getDate(date) {
  const temp = new Date(date);

  if (!date) {
    return false;
  }

  return `${temp?.getDate()} ${temp
    ?.toLocaleString('en-US', { month: 'long' })
    .slice(0, 3)} ${temp?.getFullYear()}`;
}

export default function Details({
  candidate,
  currentForm,
  setCurrentForm,
  sidePopupIsOpened,
  isModal,
  jobApplication,
  jobApplications,
  careerInfo,
  job,
}) {
  const { t } = useTranslation();
  const isAgency = useUserStore((state) => state.isAgency);
  const isClient = useUserStore((state) => state.isClient);
  function getBirthDate(date) {
    if (!date) {
      return '';
    }
    const [year, month, day] = date.split('-');

    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const monthAbbreviation = monthNames[Number(month) - 1];

    return `${Number(day)} ${t(
      `common.shortMonths.${monthAbbreviation}`
    )} ${year}`;
  }

  const userEmail = careerInfo?.email || candidate?.userProfile?.email || '-';
  const userPhone = careerInfo?.phone || candidate?.userProfile?.phone || '-';
  const userDateOfBirth =
    (careerInfo?.birthDate &&
      getBirthDate(
        new Date(careerInfo.birthDate).toISOString().slice(0, 10)
      )) ||
    getBirthDate(candidate?.userProfile?.birthDate) ||
    '-';

  const userLocation = careerInfo?.city || candidate?.userProfile?.city || '-';

  const workAuths = careerInfo?.workAuthorizations || [];
  const careerExperiences = careerInfo?.careerExperiences || [];
  const careerEducations = careerInfo?.careerEducations || [];
  const careerSkills = careerInfo?.skills || [];
  const careerLanguages = careerInfo?.careerLanguageSelections || [];

  const candidatesJobApplicationsApplied = jobApplications?.filter(
    (application) => application?.status !== 'Invited'
  );

  const [personalOpen, setPersonalOpen] = useState(true);
  const [waOpen, setWaOpen] = useState(false);
  const [expOpen, setExpOpen] = useState(false);
  const [eduOpen, setEduOpen] = useState(false);
  const [langsOpen, setLangsOpen] = useState(false);
  const [skillsOpen, setSkillsOpen] = useState(false);
  const [compOpen, setCompOpen] = useState(false);
  const [linksOpen, setLinksOpen] = useState(false);
  const [applicationOpen, setApplicationOpen] = useState(true);
  const normalizeUrl = (url) => {
    if (!url) return '';
    const trimmed = String(url).trim();
    if (!/^https?:\/\//i.test(trimmed)) return `https://${trimmed}`;
    return trimmed;
  };

  return (
    <div className={classes.details}>
      {jobApplication && isClient && (
        <div className={classes.noteContainer}>
          <p className={classes.title}>
            {t('dashboardComponents.Candidate.Details.coverMessage')}
          </p>
          <Textarea
            value={jobApplication?.coverMessage}
            readonly
            height={100}
          />
        </div>
      )}
      <div className={classes.detailsContainer}>
        <div
          className={classes.information}
          style={{ marginTop: isModal && '37px' }}
        >
          {jobApplication && (
            <div className={classes.sectionContainer}>
              <div
                className={`${classes.title} ${classes.collapsibleHeader}`}
                onClick={() => setApplicationOpen((v) => !v)}
              >
                {t('dashboardComponents.Candidate.Details.application')}
                <span
                  className={`${classes.arrow} ${
                    !applicationOpen ? classes.collapsed : ''
                  }`}
                >
                  ▾
                </span>
              </div>

              <div
                className={`${classes.application} ${
                  !applicationOpen ? classes.sectionContentCollapsed : ''
                }`}
              >
                <div className={classes.applicationDateAndJobOwner}>
                  <div className={classes.container}>
                    <p className={classes.name}>
                      {t('dashboardComponents.Candidate.Details.appliedOn')}
                    </p>
                    <p className={classes.description}>
                      {getDate(jobApplication?.createdAt)}
                    </p>
                  </div>
                  <div className={classes.container}>
                    <p className={classes.name}>
                      {t('dashboardComponents.Candidate.Details.jobOwner')}
                    </p>
                    <p className={classes.description}>
                      {job?.user?.userProfile?.fullName || '-'}
                    </p>
                  </div>
                </div>

                <div className={classes.positions}>
                  <p className={classes.text}>
                    {t(
                      'dashboardComponents.Candidate.Details.otherPositionsApplied'
                    )}
                  </p>
                  <div className={classes.rightSide}>
                    <div className={classes.amount}>
                      <span className={classes.amountNumber}>
                        {candidatesJobApplicationsApplied?.length || '0'}
                      </span>
                    </div>
                    <div
                      className={classes.seeAll}
                      onClick={() => setCurrentForm('Applications')}
                    >
                      {t('dashboardComponents.Candidate.Details.seeAll')}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className={classes.sectionContainer}>
            {/* Personal */}
            <div
              className={`${classes.title} ${classes.collapsibleHeader}`}
              onClick={() => setPersonalOpen((v) => !v)}
            >
              {t(
                'dashboardComponents.Candidate.Details.sectionTitles.personal'
              )}
              <span
                className={`${classes.arrow} ${
                  !personalOpen ? classes.collapsed : ''
                }`}
              >
                ▾
              </span>
            </div>
            <div
              className={`${classes.section} ${
                !personalOpen ? classes.sectionContentCollapsed : ''
              }`}
            >
              <div className={`${classes.row} ${classes.cols1}`}>
                <div className={classes.container}>
                  <p className={classes.name}>
                    {t('dashboardComponents.Candidate.Details.personal.email')}
                  </p>
                  <p className={classes.description}>{userEmail}</p>
                </div>
              </div>
              <div className={`${classes.row} ${classes.cols3}`}>
                <div className={classes.container}>
                  <p className={classes.name}>
                    {t('dashboardComponents.Candidate.Details.personal.phone')}
                  </p>
                  <p className={classes.description}>{userPhone}</p>
                </div>
                <div className={classes.container}>
                  <p className={classes.name}>
                    {t('dashboardComponents.Candidate.Details.personal.city')}
                  </p>
                  <p className={classes.description}>{userLocation}</p>
                </div>
                <div className={classes.container}>
                  <p className={classes.name}>
                    {t(
                      'dashboardComponents.Candidate.Details.personal.country'
                    )}
                  </p>
                  <p className={classes.description}>
                    {careerInfo?.country || '-'}
                  </p>
                </div>
              </div>
              <div className={`${classes.row} ${classes.cols3}`}>
                <div className={classes.container}>
                  <p className={classes.name}>
                    {t('dashboardComponents.Candidate.Details.personal.dob')}
                  </p>
                  <p className={classes.description}>{userDateOfBirth}</p>
                </div>
                <div className={classes.container}>
                  <p className={classes.name}>
                    {t('dashboardComponents.Candidate.Details.personal.gender')}
                  </p>
                  <p className={classes.description}>
                    {careerInfo?.gender?.name || '-'}
                  </p>
                </div>
                <div className={classes.container}>
                  <p className={classes.name}>
                    {t(
                      'dashboardComponents.Candidate.Details.personal.nationality'
                    )}
                  </p>
                  <p className={classes.description}>
                    {careerInfo?.nationality || '-'}
                  </p>
                </div>
              </div>
              <div className={`${classes.row} ${classes.cols3}`}>
                <div className={classes.container}>
                  <p className={classes.name}>
                    {t('dashboardComponents.Candidate.Details.personal.source')}
                  </p>
                  <p className={classes.description}>
                    {careerInfo?.source || '-'}
                  </p>
                </div>
                <div className={classes.container}>
                  <p className={classes.name}>
                    {t(
                      'dashboardComponents.Candidate.Details.personal.externalSource'
                    )}
                  </p>
                  <p className={classes.description}>
                    {careerInfo?.externalSource || '-'}
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Work Auth */}
          {isAgency && (
            <div className={classes.sectionContainer}>
              <div
                className={`${classes.title} ${classes.collapsibleHeader}`}
                onClick={() => setWaOpen((v) => !v)}
              >
                {t(
                  'dashboardComponents.Candidate.Details.sectionTitles.workAuth'
                )}
                <span
                  className={`${classes.arrow} ${
                    !waOpen ? classes.collapsed : ''
                  }`}
                >
                  ▾
                </span>
              </div>
              <div
                className={`${classes.section} ${
                  !waOpen ? classes.sectionContentCollapsed : ''
                }`}
              >
                {workAuths?.length ? (
                  <>
                    {workAuths.map((wa) => (
                      <div
                        key={`wa-${
                          wa?.id ||
                          wa?.country ||
                          wa?.visaType ||
                          wa?.visaStatusDate ||
                          'na'
                        }`}
                        className={`${classes.row} ${classes.cols4}`}
                      >
                        <div className={classes.container}>
                          <p className={classes.name}>
                            {t(
                              'dashboardComponents.Candidate.Details.workAuth.country'
                            )}
                          </p>
                          <p className={classes.description}>
                            {wa?.country || '-'}
                          </p>
                        </div>
                        <div className={classes.container}>
                          <p className={classes.name}>
                            {t(
                              'dashboardComponents.Candidate.Details.workAuth.status'
                            )}
                          </p>
                          <p className={classes.description}>
                            {wa?.visaStatus?.name || '-'}
                          </p>
                        </div>
                        <div className={classes.container}>
                          <p className={classes.name}>
                            {t(
                              'dashboardComponents.Candidate.Details.workAuth.visaType'
                            )}
                          </p>
                          <p className={classes.description}>
                            {wa?.visaType || '-'}
                          </p>
                        </div>
                        <div className={classes.container}>
                          <p className={classes.name}>
                            {t(
                              'dashboardComponents.Candidate.Details.workAuth.expiration'
                            )}
                          </p>
                          <p className={classes.description}>
                            {wa?.visaStatusDate
                              ? getDate(wa.visaStatusDate)
                              : '-'}
                          </p>
                        </div>
                      </div>
                    ))}
                  </>
                ) : (
                  <div
                    className={`${classes.basicInfo} ${
                      !waOpen ? classes.sectionContentCollapsed : ''
                    }`}
                  >
                    <div className={classes.container}>
                      <p className={classes.description}>-</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          {/* Experience */}
          <div className={classes.sectionContainer}>
            <div
              className={`${classes.title} ${classes.collapsibleHeader}`}
              onClick={() => setExpOpen((v) => !v)}
            >
              {t(
                'dashboardComponents.Candidate.Details.sectionTitles.experience'
              )}
              <span
                className={`${classes.arrow} ${
                  !expOpen ? classes.collapsed : ''
                }`}
              >
                ▾
              </span>
            </div>
            <div
              className={`${classes.section} ${
                !expOpen ? classes.sectionContentCollapsed : ''
              }`}
            >
              {careerExperiences?.length ? (
                <>
                  {careerExperiences.map((exp) => (
                    <>
                      <div
                        className={`${classes.row} ${classes.cols1}`}
                        key={`exp-${
                          exp?.id ||
                          exp?.empoyerName ||
                          exp?.company ||
                          exp?.jobTitle ||
                          exp?.startDate ||
                          'na'
                        }`}
                      >
                        <div className={classes.container}>
                          <p className={classes.description}>
                            {exp.jobTitle || '-'} /{' '}
                            {exp.empoyerName || exp.company || '-'} /{' '}
                            {exp.startDate ? getDate(exp.startDate) : '-'} -{' '}
                            {exp.endDate ? getDate(exp.endDate) : 'Present'}
                          </p>
                        </div>
                      </div>
                      {!!exp.summary && (
                        <div className={`${classes.row} ${classes.cols1}`}>
                          <p className={classes.summary}>{exp.summary}</p>
                        </div>
                      )}
                    </>
                  ))}
                </>
              ) : (
                <div className={classes.basicInfo}>
                  <div className={classes.container}>
                    <p className={classes.description}>-</p>
                  </div>
                </div>
              )}
            </div>
          </div>
          {/* Education */}
          <div className={classes.sectionContainer}>
            <div
              className={`${classes.title} ${classes.collapsibleHeader}`}
              onClick={() => setEduOpen((v) => !v)}
            >
              {t(
                'dashboardComponents.Candidate.Details.sectionTitles.education'
              )}
              <span
                className={`${classes.arrow} ${
                  !eduOpen ? classes.collapsed : ''
                }`}
              >
                ▾
              </span>
            </div>

            <div
              className={`${classes.section} ${
                !eduOpen ? classes.sectionContentCollapsed : ''
              }`}
            >
              {careerEducations?.length ? (
                <>
                  {careerEducations.map((ed) => (
                    <div
                      className={`${classes.exp} ${classes.row} ${classes.cols1}`}
                      key={`ed-${
                        ed?.id || ed?.institution || ed?.graduationYear || 'na'
                      }`}
                    >
                      <div className={classes.container}>
                        <p className={classes.description}>
                          {ed?.graduation?.name || '-'} /{' '}
                          {ed?.institution || '-'} / {ed?.graduationYear || '-'}
                        </p>
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <div className={classes.container}>
                  <p className={classes.description}>-</p>
                </div>
              )}
            </div>
          </div>
          {/* Languages */}
          {careerLanguages.length > 0 && (
            <div className={classes.sectionContainer}>
              <div
                className={`${classes.title} ${classes.collapsibleHeader}`}
                onClick={() => setLangsOpen((v) => !v)}
              >
                {t(
                  'dashboardComponents.Candidate.Details.sectionTitles.languages'
                )}
                <span
                  className={`${classes.arrow} ${
                    !langsOpen ? classes.collapsed : ''
                  }`}
                >
                  ▾
                </span>
              </div>
              <div
                className={`${classes.section} ${
                  !langsOpen ? classes.sectionContentCollapsed : ''
                }`}
              >
                {careerLanguages.map((lang) => (
                  <div
                    className={`${classes.row} ${classes.cols2}`}
                    key={`lang-${
                      lang?.id ||
                      lang?.language?.id ||
                      lang?.language?.name ||
                      'na'
                    }`}
                  >
                    <div className={classes.container}>
                      <p className={classes.name}>
                        {t(
                          'dashboardComponents.Candidate.Details.languages.language'
                        )}
                      </p>
                      <p className={classes.description}>
                        {lang?.language?.name || '-'}
                      </p>
                    </div>
                    <div className={classes.container}>
                      <p className={classes.name}>
                        {t(
                          'dashboardComponents.Candidate.Details.languages.level'
                        )}
                      </p>
                      <p className={classes.description}>
                        {lang?.languageLevel?.name || '-'}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          {/* Skills */}
          <div className={classes.sectionContainer}>
            <div
              className={`${classes.title} ${classes.collapsibleHeader}`}
              onClick={() => setSkillsOpen((v) => !v)}
            >
              {t('dashboardComponents.Candidate.Details.sectionTitles.skills')}
              <span
                className={`${classes.arrow} ${
                  !skillsOpen ? classes.collapsed : ''
                }`}
              >
                ▾
              </span>
            </div>
            <div
              className={`${classes.section} ${
                !skillsOpen ? classes.sectionContentCollapsed : ''
              }`}
            >
              <div className={`${classes.row} ${classes.cols1}`}>
                <div className={`${classes.container}`}>
                  <p className={classes.name}>
                    {t(
                      'dashboardComponents.Candidate.Details.skills.keySkills'
                    )}
                  </p>
                  <p className={classes.description}>
                    {careerSkills?.length
                      ? careerSkills
                          .map((s) => s?.name || s?.skillName || '')
                          .filter(Boolean)
                          .join(', ')
                      : '-'}
                  </p>
                </div>
              </div>
              <div className={`${classes.row} ${classes.cols1}`}>
                <div className={`${classes.container}`}>
                  <p className={classes.name}>
                    {t(
                      'dashboardComponents.Candidate.Details.skills.certifications'
                    )}
                  </p>
                  <p className={classes.description}>
                    {careerInfo?.certifications || '-'}
                  </p>
                </div>
              </div>
              {isAgency && (
                <div className={`${classes.row} ${classes.cols1}`}>
                  <div className={classes.container}>
                    <p className={classes.name}>
                      {t(
                        'dashboardComponents.Candidate.Details.skills.upskill'
                      )}
                    </p>
                    <p className={classes.description}>
                      {careerInfo?.willingToUpSkill == null
                        ? '-'
                        : careerInfo?.willingToUpSkill
                        ? t('common.yes')
                        : t('common.no')}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
          {/* Compensation & Availability */}
          <div className={classes.sectionContainer}>
            <div
              className={`${classes.title} ${classes.collapsibleHeader}`}
              onClick={() => setCompOpen((v) => !v)}
            >
              {t(
                'dashboardComponents.Candidate.Details.sectionTitles.compAvailability'
              )}
              <span
                className={`${classes.arrow} ${
                  !compOpen ? classes.collapsed : ''
                }`}
              >
                ▾
              </span>
            </div>
            <div
              className={`${classes.section} ${
                !compOpen ? classes.sectionContentCollapsed : ''
              }`}
            >
              <div className={`${classes.row} ${classes.cols1}`}>
                <div className={classes.container}>
                  <p className={classes.name}>
                    {t(
                      'dashboardComponents.Candidate.Details.compensation.engagementType'
                    )}
                  </p>
                  <p className={classes.description}>
                    {careerInfo?.engagementType?.name
                      ? careerInfo?.engagementType?.name
                      : '-'}
                  </p>
                </div>
              </div>

              {isAgency && (
                <>
                  <div className={`${classes.row} ${classes.cols1}`}>
                    {/* Current Compensation */}
                    <div className={classes.container}>
                      <p className={classes.name}>
                        {t(
                          'dashboardComponents.Candidate.Details.compensation.currentAmount'
                        )}
                      </p>
                      {careerInfo?.currentSalary != null ? (
                        <p className={classes.description}>
                          {String(careerInfo.currentSalary)}{' '}
                          {careerInfo?.currentSalaryCurrencyCode || '-'}{' '}
                          {careerInfo?.currentSalaryFrequency || '-'}
                        </p>
                      ) : (
                        <p className={classes.description}>-</p>
                      )}
                    </div>
                  </div>
                  {!!careerInfo?.currentSalaryInfo && (
                    <div className={`${classes.row} ${classes.cols1}`}>
                      <div className={classes.container}>
                        <p className={classes.name}>
                          {t(
                            'dashboardComponents.Candidate.Details.compensation.currentNote'
                          )}
                        </p>
                        <p className={classes.description}>
                          {careerInfo.currentSalaryInfo}
                        </p>
                      </div>
                    </div>
                  )}

                  <div className={`${classes.row} ${classes.cols1}`}>
                    {/* Expected Compensation */}
                    <div className={classes.container}>
                      <p className={classes.name}>
                        {t(
                          'dashboardComponents.Candidate.Details.compensation.expectedAmount'
                        )}
                      </p>
                      {careerInfo?.expectedSalary != null ? (
                        <p className={classes.description}>
                          {String(careerInfo.expectedSalary)}{' '}
                          {careerInfo?.expectedSalaryCurrencyCode || '-'}{' '}
                          {careerInfo?.exptecedSalaryFrequency || '-'}
                        </p>
                      ) : (
                        <p className={classes.description}>-</p>
                      )}
                    </div>
                  </div>
                  {!!careerInfo?.expectedSalaryInfo && (
                    <div className={`${classes.row} ${classes.cols1}`}>
                      <div className={classes.container}>
                        <p className={classes.name}>
                          {t(
                            'dashboardComponents.Candidate.Details.compensation.expectedNote'
                          )}
                        </p>
                        <p className={classes.description}>
                          {careerInfo.expectedSalaryInfo}
                        </p>
                      </div>
                    </div>
                  )}
                </>
              )}
              <div className={`${classes.row} ${classes.cols5}`}>
                {/* Availability */}
                {isAgency && (
                  <div className={classes.container}>
                    <p className={classes.name}>
                      {t(
                        'dashboardComponents.Candidate.Details.availability.immediateJoiner'
                      )}
                    </p>
                    <p className={classes.description}>
                      {careerInfo?.immediateJoiner
                        ? t('common.yes')
                        : t('common.no')}
                    </p>
                  </div>
                )}
                {isAgency && (
                  <div className={classes.container}>
                    <p className={classes.name}>
                      {t(
                        'dashboardComponents.Candidate.Details.availability.noticePeriod'
                      )}
                    </p>
                    <p className={classes.description}>
                      {careerInfo?.noticePeriod?.name ||
                        careerInfo?.noticePeriodId ||
                        '-'}
                    </p>
                  </div>
                )}
                {isAgency && (
                  <div className={classes.container}>
                    <p className={classes.name}>
                      {t(
                        'dashboardComponents.Candidate.Details.availability.availabilityFrom'
                      )}
                    </p>
                    <p className={classes.description}>
                      {careerInfo?.availableFrom
                        ? getDate(careerInfo.availableFrom)
                        : '-'}
                    </p>
                  </div>
                )}
                {isAgency && (
                  <div className={classes.container}>
                    <p className={classes.name}>
                      {t(
                        'dashboardComponents.Candidate.Details.availability.workShift'
                      )}
                    </p>
                    <p className={classes.description}>
                      {careerInfo?.workShift?.name ||
                        careerInfo?.workShiftId ||
                        '-'}
                    </p>
                  </div>
                )}
                <div className={classes.container}>
                  <p className={classes.name}>
                    {t(
                      'dashboardComponents.Candidate.Details.availability.shiftReadiness'
                    )}
                  </p>
                  <p className={classes.description}>
                    {careerInfo?.workShiftReadiness?.name ||
                      careerInfo?.workShiftReadinessId ||
                      '-'}
                  </p>
                </div>
              </div>
              <div className={`${classes.row} ${classes.cols5}`}>
                <div className={classes.container}>
                  <p className={classes.name}>
                    {t(
                      'dashboardComponents.Candidate.Details.availability.timezoneOverlap'
                    )}
                  </p>
                  <p className={classes.description}>
                    {careerInfo?.timeZoneOverlap || '-'}
                  </p>
                </div>
                <div className={classes.container}>
                  <p className={classes.name}>
                    {t(
                      'dashboardComponents.Candidate.Details.availability.workMode'
                    )}
                  </p>
                  <p className={classes.description}>
                    {careerInfo?.jobLocationType?.name ||
                      careerInfo?.jobLocationTypeId ||
                      '-'}
                  </p>
                </div>
                {isAgency && (
                  <div className={classes.container}>
                    <p className={classes.name}>
                      {t(
                        'dashboardComponents.Candidate.Details.availability.engagementPreference'
                      )}
                    </p>
                    <p className={classes.description}>
                      {careerInfo?.engagementPreference?.name ||
                        careerInfo?.engagementPreferenceId ||
                        '-'}
                    </p>
                  </div>
                )}

                <div className={classes.container}>
                  <p className={classes.name}>
                    {t(
                      'dashboardComponents.Candidate.Details.availability.willingToTravel'
                    )}
                  </p>
                  <p className={classes.description}>
                    {careerInfo?.willingToTravel == null
                      ? '-'
                      : careerInfo?.willingToTravel
                      ? t('common.yes')
                      : t('common.no')}
                  </p>
                </div>

                <div className={classes.container}>
                  <p className={classes.name}>
                    {t(
                      'dashboardComponents.Candidate.Details.availability.travelPercentage'
                    )}
                  </p>
                  <p className={classes.description}>
                    {careerInfo?.travelPercentage || '-'}
                  </p>
                </div>
              </div>
              {isAgency && (
                <div className={`${classes.row} ${classes.cols2}`}>
                  <div className={classes.container}>
                    <p className={classes.name}>
                      {t(
                        'dashboardComponents.Candidate.Details.availability.willingToRelocate'
                      )}
                    </p>
                    <p className={classes.description}>
                      {careerInfo?.willingToRelocate == null
                        ? '-'
                        : careerInfo?.willingToRelocate
                        ? t('common.yes')
                        : t('common.no')}
                    </p>
                  </div>
                  <div className={classes.container}>
                    <p className={classes.name}>
                      {t(
                        'dashboardComponents.Candidate.Details.availability.relocateCities'
                      )}
                    </p>
                    <p className={classes.description}>
                      {careerInfo?.travelCities || '-'}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
          {/* Links */}
          <div className={classes.sectionContainer}>
            <div
              className={`${classes.title} ${classes.collapsibleHeader}`}
              onClick={() => setLinksOpen((v) => !v)}
            >
              {t('dashboardComponents.Candidate.Details.links.title')}
              <span
                className={`${classes.arrow} ${
                  !linksOpen ? classes.collapsed : ''
                }`}
              >
                ▾
              </span>
            </div>
            <div
              className={`${classes.section} ${
                !linksOpen ? classes.sectionContentCollapsed : ''
              }`}
            >
              <div className={`${classes.row} ${classes.cols3}`}>
                <div className={classes.container}>
                  <p className={classes.name}>
                    {t('dashboardComponents.Candidate.Details.links.linkedin')}
                  </p>
                  {careerInfo?.linkedIn ? (
                    <a
                      className={classes.description}
                      href={normalizeUrl(careerInfo.linkedIn)}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {careerInfo.linkedIn}
                    </a>
                  ) : (
                    <p className={classes.description}>-</p>
                  )}
                </div>
                <div className={classes.container}>
                  <p className={classes.name}>
                    {t('dashboardComponents.Candidate.Details.links.github')}
                  </p>
                  {careerInfo?.github ? (
                    <a
                      className={classes.description}
                      href={normalizeUrl(careerInfo.github)}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {careerInfo.github}
                    </a>
                  ) : (
                    <p className={classes.description}>-</p>
                  )}
                </div>
                <div className={classes.container}>
                  <p className={classes.name}>
                    {t('dashboardComponents.Candidate.Details.links.portfolio')}
                  </p>
                  {careerInfo?.portfolio ? (
                    <a
                      className={classes.description}
                      href={normalizeUrl(careerInfo.portfolio)}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {careerInfo.portfolio}
                    </a>
                  ) : (
                    <p className={classes.description}>-</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <VideoResume
          candidate={candidate}
          sidePopupIsOpened={sidePopupIsOpened}
          currentForm={currentForm}
          isModal={isModal}
          jobApplication={jobApplication}
          job={job}
        />
      </div>
    </div>
  );
}
